import { FUEL_HISTORY } from "./apiRequest";

export const FUEL_HISTORY_ADD_FILES = (id: string) =>
  `${FUEL_HISTORY}${id}/bulk_add_files/`;
